import { useAsyncEffect, useLocalStorageState } from 'ahooks';
import { Drawer, Badge } from 'antd';
import { observer } from 'mobx-react-lite';
import React, { Fragment, useState } from 'react';
import { useHistory } from 'react-router-dom';
import IssueRecommendIcon from '@/assets/images/header/issue-recommend.svg?react';
import { pushHistory } from '@/infrastructure/history';
import { TopMenuButton } from '@/presentation/layouts/header/button';
import { useStores } from '@/presentation/store';
import { hintText } from '../hint-text/hintText';
import { IssueRecommendList } from './recommend-list';
import { useTranslation } from 'react-i18next';


export const IssueRecommend = observer(() => {
  const { t } = useTranslation();
  const {} = {};
  const history = useHistory();
  const [visible, setVisible] = useState(false);
  const { loadRecommendOpenStatus, issueRecommendOpen } = useStores().ConfigStore;
  const [enableDot, setEnableDot] = useLocalStorageState('issue-recommend-entry', {
    defaultValue: true,
  });

  const onClick = () => {
    setVisible(true);
    setEnableDot(false);
  };

  const toRepoPage = () => {
    pushHistory(history, '/setting/product-config', {
      tab: 'recommentRepo',
    });
    setVisible(false);
  };

  const tips = (
    <div>
      {t("智能推荐与个人相关的严重问题，使用前需要授权")}<a onClick={toRepoPage}>{t("代码仓库")}</a>{t("权限")}
    </div>
  );

  useAsyncEffect(async () => {
    loadRecommendOpenStatus();
  }, []);

  return (
    <Fragment>
      {issueRecommendOpen && <TopMenuButton onClick={onClick}>
        <IssueRecommendIcon />
        <Badge dot={enableDot} offset={[2, -2]}><span>{t("问题推荐")}</span></Badge>
      </TopMenuButton>}

      <Drawer
        width={648}
        title={hintText(t("问题推荐"), tips)}
        visible={visible}
        onClose={() => setVisible(false)}
        bodyStyle={{ padding: '0 24px' }}
      >
        <IssueRecommendList />
      </Drawer>
    </Fragment>
  );
});
